import { ContentState } from 'draft-js';

import LegacyGalleryComponent from './LegacyGalleryComponent';
import NewGalleryComponent from './NewGalleryComponent';

const GalleryComponent = ({ ...rest }) => {
  const { block } = rest;
  const isNewGallery = () => {
    const contentState = ContentState.createFromBlockArray([block]);
    const ent = block.getEntityAt(0);
    const entity = contentState.getEntity(ent);
    const { data, config } = entity.data;
    return data.length === 0 || (config && Object.keys(config).length > 0);
  };

  if (isNewGallery()) {
    return <NewGalleryComponent {...rest} />;
  }
  return <LegacyGalleryComponent {...rest} />;
};

export default GalleryComponent;
